import { Flow } from 'signup-constants/Flow';
export const RequiredQueryParamsByFlow = new Map([[Flow.Integrations, ['integration']], [Flow.Microapp, ['microapp']], [Flow.Trial, ['trialid']]]);